export default __webpack_public_path__ + "static/img10v-f868aec501fbca0085b32ac61b30a8ec.jpg";